module.exports = __webpack_public_path__ + "media/images/Stream-76e3bdcf.jpg";